class SlideshowBanner {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.slideshow-banner__track');
    this.slides = Array.from(el.querySelectorAll('.slideshow-banner__slide'));
    this.dots = Array.from(el.querySelectorAll('.slideshow-banner__dot'));
    this.prevBtn = el.querySelector('.slideshow-banner__arrow--prev');
    this.nextBtn = el.querySelector('.slideshow-banner__arrow--next');
    this.current = 0;
    this.autoplay = el.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(el.dataset.autoplaySpeed, 10) || 5000;
    this.timer = null;

    this.updateHeight(this.current);
    window.addEventListener('resize', () => this.updateHeight(this.current));

    if (this.slides.length <= 1) return;

    this.prevBtn && this.prevBtn.addEventListener('click', () => this.go(this.current - 1));
    this.nextBtn && this.nextBtn.addEventListener('click', () => this.go(this.current + 1));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

    this.el.addEventListener('mouseenter', () => this.stop());
    this.el.addEventListener('mouseleave', () => this.start());

    this.start();
  }

  updateHeight(index) {
    if (!this.track) return;
    const slide = this.slides[index];
    if (!slide) return;
    const isMobile = window.innerWidth < 750;
    const varName = isMobile ? '--ratio-mobile' : '--ratio-desktop';
    const ratio = parseFloat(getComputedStyle(slide).getPropertyValue(varName)) || 2;
    const width = this.track.offsetWidth;
    if (width > 0 && ratio > 0) {
      this.track.style.height = (width / ratio) + 'px';
    }
  }

  go(index) {
    const total = this.slides.length;
    this.current = (index + total) % total;
    this.updateHeight(this.current);
    this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.current));
    this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.current));
    this.restart();
  }

  start() {
    if (!this.autoplay) return;
    this.stop();
    this.timer = setInterval(() => this.go(this.current + 1), this.autoplaySpeed);
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  restart() {
    if (this.autoplay) this.start();
  }
}

document.querySelectorAll('.slideshow-banner').forEach((el) => new SlideshowBanner(el));
